import ContractsTaxiForwardingContractAddRequest, {
  ContractsTaxiForwardingContractAddRequestModel,
} from "../../../../api/raily/contracts/taxi-forwarding/add/contracts-taxi-forwarding-contract-add.request";
import BillingModel from "../../../../types/billing-model";
import ContractsTaxiForwardingContractAddParams from "./contracts-taxi-forwarding-contract-add-params";

const createBillingModel = (
  requestBillingModel: BillingModel,
): ContractsTaxiForwardingContractAddRequestModel => {
  switch (requestBillingModel) {
    case BillingModel.AB:
      return ContractsTaxiForwardingContractAddRequestModel.AB;
    case BillingModel.ABA:
      return ContractsTaxiForwardingContractAddRequestModel.ABA;
    case BillingModel.OTHER:
      return ContractsTaxiForwardingContractAddRequestModel.OTHER;
    case BillingModel.SABS:
      return ContractsTaxiForwardingContractAddRequestModel.SABS;
  }
};

const create = (
  params: ContractsTaxiForwardingContractAddParams,
): ContractsTaxiForwardingContractAddRequest => {
  return {
    consumerTaxiId: params.consumerTaxiUuid,
    disabled: !params.isActive,
    distanceRate: params.distanceRate,
    haltingTimeAfterMinutes: params.freeStoppingPeriodMinutes,
    haltingTimeRate: params.stoppingRate,
    model: createBillingModel(params.billingModel),
    producerTaxiId: params.producerTaxiUuid,
    validSince: params.periodOfValidation.from,
    validTo: params.periodOfValidation.to,
    displayName: params.displayName,
    isPartner: params.isPartner,
    priority: params.priority,
  };
};

const contractsTaxiForwardingContractAddParamsFactory = {
  create,
};

export default contractsTaxiForwardingContractAddParamsFactory;
